var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{ref:"baseForm",staticClass:"d-ueditor-editor-container",attrs:{"showSubmitButton":false,"form":_vm.value,"formItems":_vm.getFormItems,"labelWidth":_vm.labelWidth,"rules":_vm.rules,"popperAppendToBody":false}})}
var staticRenderFns = []

export { render, staticRenderFns }